import { CheckCircle2, Clock, XCircle, SkipForward, Ban } from 'lucide-react';
import { NAVY, AMBER, BORDER_COLOR } from '../../styles/tokens';

const LEVEL_LABELS = {
  1: 'Supervisor Directo',
  2: 'Gerente',
  3: 'Administración',
  4: 'Recursos Humanos',
  5: 'Directora',
};

const STATUS_CONFIG = {
  waiting:   { icon: Clock,        color: '#94a3b8', bg: '#f1f5f9', label: 'En espera' },
  pending:   { icon: Clock,        color: '#eab308', bg: '#fef9c3', label: 'Pendiente' },
  approved:  { icon: CheckCircle2, color: '#16a34a', bg: '#dcfce7', label: 'Aprobado' },
  rejected:  { icon: XCircle,      color: '#dc2626', bg: '#fee2e2', label: 'Rechazado' },
  skipped:   { icon: SkipForward,  color: '#64748b', bg: '#f1f5f9', label: 'Omitido' },
  cancelled: { icon: Ban,          color: '#94a3b8', bg: '#f1f5f9', label: 'Cancelado' },
};

function formatDateTime(d) {
  if (!d) return '';
  return new Date(d).toLocaleDateString('es-PR', {
    day: 'numeric', month: 'short', year: 'numeric',
    hour: '2-digit', minute: '2-digit',
  });
}

export default function ApprovalChainTimeline({ chain = [] }) {
  if (!chain.length) return null;

  return (
    <div style={{ padding: '4px 0' }}>
      <div style={{ fontSize: 13, fontWeight: 700, color: NAVY, marginBottom: 12 }}>
        Cadena de Aprobación
      </div>
      <div style={{ position: 'relative' }}>
        {chain.map((record, idx) => {
          const cfg = STATUS_CONFIG[record.status] || STATUS_CONFIG.waiting;
          const Icon = cfg.icon;
          const isLast = idx === chain.length - 1;

          return (
            <div key={record.level} style={{ display: 'flex', gap: 12, position: 'relative' }}>
              {/* Vertical connector line */}
              {!isLast && (
                <div style={{
                  position: 'absolute', left: 15, top: 32, bottom: -8,
                  width: 2, background: record.status === 'approved' || record.status === 'skipped'
                    ? '#16a34a' : BORDER_COLOR,
                }} />
              )}

              {/* Icon circle */}
              <div style={{
                width: 32, height: 32, borderRadius: '50%',
                background: cfg.bg, border: `2px solid ${cfg.color}`,
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                flexShrink: 0, zIndex: 1,
              }}>
                <Icon size={16} color={cfg.color} />
              </div>

              {/* Content */}
              <div style={{ flex: 1, paddingBottom: isLast ? 0 : 16 }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                  <span style={{ fontSize: 13, fontWeight: 600, color: NAVY }}>
                    Nivel {record.level} — {LEVEL_LABELS[record.level]}
                  </span>
                  <span style={{
                    fontSize: 10, fontWeight: 600, padding: '1px 8px',
                    borderRadius: 10, background: cfg.bg, color: cfg.color,
                  }}>
                    {cfg.label}
                  </span>
                </div>

                {record.approver_display_name || record.approver_name ? (
                  <div style={{ fontSize: 12, color: '#64748b', marginTop: 2 }}>
                    {record.approver_display_name || record.approver_name}
                    {record.approver_email && (
                      <span style={{ color: '#94a3b8' }}> · {record.approver_email}</span>
                    )}
                  </div>
                ) : record.status === 'skipped' ? (
                  <div style={{ fontSize: 12, color: '#94a3b8', marginTop: 2, fontStyle: 'italic' }}>
                    Sin asignar — nivel omitido
                  </div>
                ) : null}

                {record.comments && (
                  <div style={{
                    marginTop: 6, padding: '6px 10px', borderRadius: 6,
                    background: record.status === 'rejected' ? '#fef2f2' : '#f8fafc',
                    border: `1px solid ${record.status === 'rejected' ? '#fecaca' : BORDER_COLOR}`,
                    fontSize: 12, color: NAVY,
                  }}>
                    {record.comments}
                  </div>
                )}

                {record.responded_at && (
                  <div style={{ fontSize: 11, color: '#94a3b8', marginTop: 3 }}>
                    {formatDateTime(record.responded_at)}
                  </div>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
